import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import FLAGS from '../../data/flags';

const styles = ({ palette, sizes }) => ({
    flag: {
        width: '32px',
        height: '22px',

        backgroundImage: 'url(./static/images/flags.png)',
        backgroundSize: '224px 66px',
        backgroundRepeat: 'no-repeat',

    }
});

export default  withStyles(styles)(({ country, classes, className, ...props}) => (
    <div style={{backgroundPosition: FLAGS[country]}} className={classNames(classes.flag, className)} {...props}/>
))